const BannerSection = () => {
  const awsImageBaseUrl = process.env.REACT_APP_AWS_IMAGE_BUCKET_URL; 
  return (
    <section className="py-3">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-12 text-center">
            <img src={`${awsImageBaseUrl}images/WhatWeDo/infographic_v2.png`}  className="img-fluid w-100" alt="Hero Background" />
          </div>
        </div>
        <div className="row text-center text-sm-sm">
          <div className="col pb-4">
            <p className='font-bold'>1. Name conception <span className='d-none d-lg-block'></span>and creation</p>
          </div>
          <div className="col pb-4">
            <p className='font-bold'>2. Landscape <span className='d-none d-lg-block'></span>exploration</p>
          </div>
          <div className="col pb-4">
            <p className='font-bold'>3. Ethos and essence <span className='d-none d-lg-block'></span>discovery</p>
          </div>
          <div className="col pb-4">
            <p className='font-bold'>4. Brand architecture assessment <span className='d-none d-lg-block'></span>& corporate <span className='d-none d-lg-block'></span>identity development</p>
          </div>
        </div>
        <div className="row text-left">
          <div className="col py-4">
            <img src={`${awsImageBaseUrl}images/WhatWeDo/Frame_v2.png`} className="img-fluid" alt="Hero Background" />
            </div>
        </div>
        <div className="row text-left">
          <div className="col pb-4">
            <p>At Brand Acumen Studios, we don’t just create brands, we architect catalysts for growth. Whether naming a breakthrough pharmaceutical, creating the identity for a new-to-the world innovation, or repositioning a heritage CPG brand, we combine creativity, cognitive science, and market precision to forge unforgettable IP that endures. Every engagement begins with bold questions and ends with clear, actionable solutions that move markets and minds.
            </p>
            <p>Here’s how we help you win:</p>
            <ul className='text-left'>
              <li><span className='font-bold'>Brand Equity & Financial Impact Analysis</span></li>
              <li><span className='font-bold'>Global Brand Name Creation & Validation</span></li>
              <li><span className='font-bold'>Pharmaceutical & Regulated Product Naming</span></li>
              <li><span className='font-bold'>Strategic Brand Architecture & Portfolio Planning</span></li>
              <li><span className='font-bold'>Trademark & Linguistic Risk Assessment</span></li>
              <li><span className='font-bold'>Consumer Insight Research & Message Testing</span></li>
              <li><span className='font-bold'>AI-Powered Linguistic & Semantic Modeling (ReLAA)</span></li>
              <li><span className='font-bold'>Naming Narrative Development & Stakeholder Alignment</span></li>
            </ul>
            <p>Your brand isn’t just a name. It’s your signal to the world—and we make sure it resonates.
            </p>
            <p className='font-bold'>Let’s build the brand they remember. Let’s make it iconic.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BannerSection;
